import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fullscreenCenteredContainer"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle" }, "Please wait...", -1);
const _hoisted_3 = { class: "columns" };
const _hoisted_4 = { class: "columns" };
import { reactive, getCurrentInstance, onMounted } from "vue";
import { useRoute } from "vue-router";
import { validatePasswordReset, applyPasswordReset } from "@/core/session";
import { notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { Validations } from "@/composables/useValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PasswordReset',
    setup(__props) {
        var _a, _b, _c, _d;
        const instance = getCurrentInstance();
        const userType = ((_a = useRoute().query.userType) === null || _a === void 0 ? void 0 : _a.toString()) || "";
        const email = (_b = useRoute().query.email) === null || _b === void 0 ? void 0 : _b.toString();
        const token = (_c = useRoute().query.token) === null || _c === void 0 ? void 0 : _c.toString();
        const isNewAccount = (_d = useRoute().query.isNewAccount) === null || _d === void 0 ? void 0 : _d.toString();
        const proceedToLogin = () => {
            instance.proxy.$router.push("/");
        };
        if (!["networkAdmin", "partner"].includes(userType) || !email || !token) {
            notifyError("Invalid password reset URL");
            proceedToLogin();
        }
        const passwordResetState = reactive({
            inProgress: false,
            password: "",
            repeatPassword: ""
        });
        const resetPassword = () => {
            if (!(Validations.notEmpty(passwordResetState.password) && passwordResetState.password.length >= 8 && passwordResetState.password == passwordResetState.repeatPassword)) {
                notifyError("Please make sure the passwords match, and are at least 8 characters long");
                return;
            }
            passwordResetState.inProgress = true;
            applyPasswordReset(userType, email, token, passwordResetState.password)
                .then(() => {
                notifySuccess("Password reset successfully!");
                proceedToLogin();
            })
                .catch(() => {
                notifyError("Password reset failed");
                passwordResetState.inProgress = false;
            });
        };
        onMounted(() => {
            passwordResetState.inProgress = true;
            validatePasswordReset(userType, email, token)
                .then((isValid) => {
                if (isValid) {
                    passwordResetState.inProgress = false;
                }
                else {
                    notifyError("Invalid or expired password reset link");
                    proceedToLogin();
                }
            })
                .catch((err) => notifyNetworkError("Failed to verify password reset link", err));
        });
        return (_ctx, _cache) => {
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (passwordResetState.inProgress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_LoadingSpinner, {
                            size: "large",
                            style: { "margin-bottom": "10px" }
                        }),
                        _hoisted_2
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_ModalDialog, {
                    active: !passwordResetState.inProgress,
                    title: _unref(isNewAccount) == 'true' ? 'Choose Your Password' : 'Reset Password',
                    "first-button-text": _unref(isNewAccount) == 'true' ? 'Set Password' : 'Reset Password',
                    "first-button-severity": "primary",
                    onFirstbuttonselected: _cache[2] || (_cache[2] = ($event) => (resetPassword()))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_FormTextField, {
                                    label: "Please enter your new password",
                                    placeholder: "Password",
                                    isPassword: true,
                                    modelValue: passwordResetState.password,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((passwordResetState.password) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_FormTextField, {
                                    label: "Repeat Password",
                                    placeholder: "Repeat Password",
                                    isPassword: true,
                                    modelValue: passwordResetState.repeatPassword,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((passwordResetState.repeatPassword) = $event))
                                }, null, 8, ["modelValue"])
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["active", "title", "first-button-text"])
            ], 64));
        };
    }
});
